import type { FrontendWidget } from '../types';
import { LocationMapComponent } from './LocationMapComponent';
import type { LocationMapConfig, LocationMapResolved } from './types';

export const locationMapWidget: FrontendWidget<
  LocationMapConfig,
  LocationMapResolved
> = {
  componentType: 'widgets.location-map',
  displayName: 'Location Map',
  ComponentA: LocationMapComponent,
  resolveSync: (config) => config,
};
